// Section5.jsx — Hero: split layout, content left / image right, white background
import React, { useEffect, useState } from 'react';
import { useParallax } from '../../componets/useScrollFX';
const heroBanner =
  "/assets/Mobile%20App%20Development%20Service%20for%20Your%20Business%20Growth.webp";

const Section5 = () => {
  const [mounted, setMounted] = useState(false);
  const [imgRef, imgOffset] = useParallax(0.06);

  useEffect(() => setMounted(true), []);

  return (
    <section className="relative bg-white overflow-hidden">
      {/* Ambient glow accents */}
      <div className="pointer-events-none absolute -top-32 -left-32 w-[26rem] h-[26rem] bg-[#cd2122]/8 rounded-full blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 right-0 w-[22rem] h-[22rem] bg-[#cd2122]/5 rounded-full blur-3xl" />
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.035]"
        style={{ backgroundImage: 'radial-gradient(#535353 1px, transparent 1px)', backgroundSize: '28px 28px' }}
      />

      <div className="max-w-7xl mx-auto px-6 relative pt-14 pb-14 md:pt-[80px] md:pb-[70px]">
        <div className="grid lg:grid-cols-2 gap-5 md:gap-14 items-center">
          {/* Left: Content */}
          <div className="max-w-xl">
            <div
              className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#cd2122]/20 bg-[#cd2122]/5 text-[#cd2122] text-xs font-semibold tracking-widest uppercase mb-7 transition-all duration-700 ${
                mounted ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-3'
              }`}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-[#cd2122] animate-pulse" />
              Mobile App Development
            </div>

            <h1
              className={`text-[28px] sm:text-[34px] md:text-[40px] leading-[1.15] tracking-tight font-extrabold text-[#1a1a1a] mb-6 transition-all duration-700 delay-100 ${
                mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Mobile App Development Service for{' '}
              <span className="relative inline-block">
                <span className="relative z-10 bg-gradient-to-r from-[#ff6a3d] to-[#cd2122] bg-clip-text text-transparent">
                  Your Business Growth
                </span>
                <svg className="absolute left-0 -bottom-1 w-full h-2.5 text-[#cd2122]/50" viewBox="0 0 300 12" preserveAspectRatio="none">
                  <path d="M0 8 Q75 0 150 6 T300 4" stroke="currentColor" strokeWidth="4" fill="none" strokeLinecap="round" />
                </svg>
              </span>
            </h1>

            <p
              className={`text-[#535353] text-[16px] leading-relaxed mb-5 transition-all duration-700 delay-200 ${
                mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
            >
              Transform your ideas into high-performing mobile app development solutions with Mean3. We make custom mobile apps. They help businesses engage customers. They also streamline operations, boost revenue, and grow quickly.
            </p>

            <p
              className={`text-[#535353] text-[16px] leading-relaxed mb-9 transition-all duration-700 delay-300 ${
                mounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
            >
              If you're launching a startup, updating processes, or making a mobile app, we can help. Our team offers secure and scalable solutions that match your goals.
            </p>

            <div
              className={`flex flex-wrap items-center gap-5 transition-all duration-700 delay-500 ${
                mounted ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-6 scale-95'
              }`}
            >
              <a
                href="/"
                className="group relative inline-flex items-center gap-2 bg-[#cd2122] hover:bg-[#a81c1e] text-white px-6 py-4 rounded-full font-semibold text-[12px] md:text-[16px] transition-all duration-300 shadow-lg shadow-[#cd2122]/20 hover:shadow-2xl hover:shadow-[#cd2122]/30 hover:-translate-y-0.5"
              >
                Ready to turn your idea into a real mobile app?
                <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
              </a>
            </div>
          </div>

          {/* Right: Image */}
          <div
            className={`relative transition-all duration-700 delay-200 ${
              mounted ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
            }`}
          >
            <div className="absolute -inset-4 bg-gradient-to-br from-[#cd2122]/15 to-transparent rounded-[2rem] blur-2xl" />
            <div
              ref={imgRef}
              className="relative rounded-[2rem] overflow-hidden border border-black/5 shadow-2xl"
              style={{ transform: `translateY(${imgOffset}px)` }}
            >
              <img
                src={heroBanner}
                alt="Mobile app development service for your business growth"
                className="w-full object-cover"
              />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Section5;